import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./domain/app/App";

ReactDOM.render(<App />, document.getElementById("root"));
